import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import SelectWithAddEditControlView from '../SelectWithAddEditControlView';
import ImageDestinationLocationAddForm from './ImageDestinationLocationAddForm';

const ImageDestinationLocationSelection = React.createClass({
    propTypes: {
        onChange: PropTypes.func.isRequired,
        onModeChanged: PropTypes.func,
        value: PropTypes.string.isRequired,
        forAgent: PropTypes.string.isRequired,
        locations: PropTypes.array.isRequired,
        autoFocus: PropTypes.bool,
    },
    createImageDestinationLocationAddForm: function (onSuccess, onCancel) {
        return <ImageDestinationLocationAddForm forAgent={this.props.forAgent} onSuccess={onSuccess} onCancel={onCancel} />;  
    },
    render: function() {
        const { locations, value, autoFocus, onChange, onModeChanged } = this.props;

        return <SelectWithAddEditControlView 
            label="Folder"
            setupNewLabel="Add new image location..." 
            items={locations} 
            value={value} 
            autoFocus={autoFocus}
            onChange={onChange} 
            onModeChanged={onModeChanged} 
            addFormCreator={this.createImageDestinationLocationAddForm} />;
    }
});

const mapStateToProps = (state) => ({
    locations: Array.from(state.imageDestinationLocations.value.values()).map(loc => ({
        id: loc.id,
        name: loc.uncPath
    }))
});

export default connect(mapStateToProps)(ImageDestinationLocationSelection);


// WEBPACK FOOTER //
// ./src/components/common/ImageDestinationLocationSelection/index.jsx